import { useQueryString } from "hooks/general-hooks";
import { SPECS_TO_HERO_TREES } from "lib/classes-and-specs";
import { updateQueryParamsIfChanged } from "lib/general-helper";
import { getHeroTalentQueryParamFormat } from "lib/wowHelpers";
import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";

export function useHeroQueryParams(displayClassName, displaySpecName) {
  const params = useQueryString();
  const history = useHistory();
  const location = useLocation();
  const heroArray = SPECS_TO_HERO_TREES[displayClassName].specs[displaySpecName];

  let initialState = "left";
  if (params.hasOwnProperty("hero") && params["hero"] === getHeroTalentQueryParamFormat(heroArray[1])) {
    initialState = "right";
  }

  const [selectedHero, setSelectedHero] = useState(initialState);

  useEffect(() => {
    if (!params.hasOwnProperty("hero")) {
      params["hero"] = getHeroTalentQueryParamFormat(heroArray[0]);
      updateQueryParamsIfChanged(history, location, params);
    } else {
      const paramHeroTree = params["hero"];
      const leftTreeName = getHeroTalentQueryParamFormat(heroArray[0]);
      const rightTreeName = getHeroTalentQueryParamFormat(heroArray[1]);

      // This handles any cases in which that the query param has been changed.
      if (paramHeroTree === leftTreeName) {
        setSelectedHero("left");
      } else if (paramHeroTree === rightTreeName) {
        setSelectedHero("right");
      } else {
        params["hero"] = getHeroTalentQueryParamFormat(heroArray[0]);
      }

      updateQueryParamsIfChanged(history, location, params);
    }
  }, []);

  // This use effect sets the selection of the HeroTalentSelector.
  useEffect(() => {
    const heroArray = SPECS_TO_HERO_TREES[displayClassName].specs[displaySpecName];
    const selectedHeroTree = selectedHero == "left" ? 0 : 1;
    params["hero"] = getHeroTalentQueryParamFormat(heroArray[selectedHeroTree]);
    updateQueryParamsIfChanged(history, location, params);
  }, [selectedHero]);

  // This useEffect handles when the user navigates back - reloads the page when it's a diff selected hero
  useEffect(() => {
    const paramHeroTree = params["hero"];
    const leftTreeName = getHeroTalentQueryParamFormat(heroArray[0]);
    const rightTreeName = getHeroTalentQueryParamFormat(heroArray[1]);

    if (paramHeroTree === leftTreeName && selectedHero === "right") {
      setSelectedHero("left");
    } else if (paramHeroTree === rightTreeName && selectedHero === "left") {
      setSelectedHero("right");
    }
    const selectedHeroTree = selectedHero == "left" ? 0 : 1;
    params["hero"] = getHeroTalentQueryParamFormat(heroArray[selectedHeroTree]);
    updateQueryParamsIfChanged(history, location, params);
  }, [params]);

  return { selectedHero, setSelectedHero };
}
